import {Pipe, PipeTransform} from '@angular/core';
import {Util} from "../../app/util";

/**
 * Generated class for the FilterPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
    name: 'filterIndex',
    pure: false
})
export class FilterIndexPipe implements PipeTransform {

    constructor(public util: Util) {


    }


    transform(items: any[], indexMax: number, indexMin: number = 0): any[] {

        if (!items) return [];
        return items.filter((item, index) => (index >= indexMin && index <= indexMax));

    }

}



// WEBPACK FOOTER //
// ./src/pipes/filter-index/filter-index.ts